/**
 * Khalsa Traders International - Copper & Brass Products for Restaurants
 * Frontend UI Prototype JavaScript
 */

document.addEventListener('DOMContentLoaded', () => {

  /* ==========================================================================
     1. Hero Slider Component
     ========================================================================== */
  const heroSlider = (() => {
    const slides = document.querySelectorAll('.hero-slide');
    const dots = document.querySelectorAll('.pagination-dot');
    const prevBtn = document.getElementById('hero-prev');
    const nextBtn = document.getElementById('hero-next');
    const sliderContainer = document.getElementById('hero-slider');

    if (!slides.length) return;

    let currentSlide = 0;
    const totalSlides = slides.length;
    let autoPlayInterval = null;
    const slideDuration = 6500; // 6.5s per slide

    function goToSlide(index) {
      // Normalize index
      if (index < 0) {
        currentSlide = totalSlides - 1;
      } else if (index >= totalSlides) {
        currentSlide = 0;
      } else {
        currentSlide = index;
      }

      // Update slide classes
      slides.forEach((slide, idx) => {
        if (idx === currentSlide) {
          slide.classList.add('active');
          slide.setAttribute('aria-hidden', 'false');
        } else {
          slide.classList.remove('active');
          slide.setAttribute('aria-hidden', 'true');
        }
      });

      // Update dots
      dots.forEach((dot, idx) => {
        if (idx === currentSlide) {
          dot.classList.add('active');
          dot.setAttribute('aria-selected', 'true');
        } else {
          dot.classList.remove('active');
          dot.setAttribute('aria-selected', 'false');
        }
      });
    }

    function nextSlide() {
      goToSlide(currentSlide + 1);
    }

    function prevSlide() {
      goToSlide(currentSlide - 1);
    }

    function startAutoPlay() {
      stopAutoPlay();
      autoPlayInterval = setInterval(nextSlide, slideDuration);
    }

    function stopAutoPlay() {
      if (autoPlayInterval) {
        clearInterval(autoPlayInterval);
        autoPlayInterval = null;
      }
    }

    // Event Listeners
    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        nextSlide();
        startAutoPlay();
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        prevSlide();
        startAutoPlay();
      });
    }

    dots.forEach((dot) => {
      dot.addEventListener('click', (e) => {
        const slideIndex = parseInt(e.target.getAttribute('data-slide-to'), 10);
        if (!isNaN(slideIndex)) {
          goToSlide(slideIndex);
          startAutoPlay();
        }
      });
    });

    // Pause on hover
    if (sliderContainer) {
      sliderContainer.addEventListener('mouseenter', stopAutoPlay);
      sliderContainer.addEventListener('mouseleave', startAutoPlay);
    }

    // Keyboard navigation
    document.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        prevSlide();
        startAutoPlay();
      } else if (e.key === 'ArrowRight') {
        nextSlide();
        startAutoPlay();
      }
    });

    // Initialize first slide & autoplay
    goToSlide(0);
    startAutoPlay();
  })();


  /* ==========================================================================
     2. FAQ Accordion Component
     ========================================================================== */
  const faqAccordion = (() => {
    const faqItems = document.querySelectorAll('.faq-item');
    if (!faqItems.length) return;

    faqItems.forEach((item) => {
      const trigger = item.querySelector('.faq-trigger');
      const content = item.querySelector('.faq-content');

      if (!trigger || !content) return;

      trigger.addEventListener('click', () => {
        const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

        // Close all other open items for clean luxury feel
        faqItems.forEach((otherItem) => {
          if (otherItem !== item) {
            const otherTrigger = otherItem.querySelector('.faq-trigger');
            const otherContent = otherItem.querySelector('.faq-content');

            if (otherTrigger && otherContent) {
              otherTrigger.setAttribute('aria-expanded', 'false');
              otherContent.style.maxHeight = '0px';
              otherContent.classList.remove('is-open');
              otherContent.setAttribute('hidden', '');
            }
          }
        });

        // Toggle current item
        if (isExpanded) {
          trigger.setAttribute('aria-expanded', 'false');
          content.style.maxHeight = '0px';
          content.classList.remove('is-open');
          setTimeout(() => {
            if (trigger.getAttribute('aria-expanded') === 'false') {
              content.setAttribute('hidden', '');
            }
          }, 350);
        } else {
          content.removeAttribute('hidden');
          trigger.setAttribute('aria-expanded', 'true');
          content.classList.add('is-open');
          content.style.maxHeight = content.scrollHeight + 30 + 'px';
        }
      });
    });
  })();


  /* ==========================================================================
     2. FAQ Accordion Component
     ========================================================================== */


  /* ==========================================================================
     8. Interactive Wishlist Buttons
     ========================================================================== */
  const wishlistButtons = (() => {
    const btns = document.querySelectorAll('.card-wishlist-btn');
    btns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const isFavorited = btn.classList.toggle('is-favorited');
        const svg = btn.querySelector('svg');
        if (isFavorited) {
          svg.setAttribute('fill', '#e6a36a');
          svg.setAttribute('stroke', '#e6a36a');
          btn.style.borderColor = 'var(--brand-copper)';
        } else {
          svg.setAttribute('fill', 'none');
          svg.setAttribute('stroke', 'currentColor');
          btn.style.borderColor = 'rgba(255, 255, 255, 0.15)';
        }
      });
    });
  })();


  /* ==========================================================================
     9. Smooth Anchor Scrolling Offset Compensation
     ========================================================================== */
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener('click', function (e) {
      if (this.classList.contains('quick-view-btn') || 
          this.classList.contains('btn-deal-bulk') || 
          this.classList.contains('product-arrow-link')) {
        return; // Handled by B2B Bulk Order Enquiry Modal
      }

      const targetId = this.getAttribute('href');
      if (!targetId || targetId === '#') return;

      const targetElement = document.querySelector(targetId);
      if (targetElement) {
        e.preventDefault();
        const headerHeight = document.getElementById('site-header')?.offsetHeight || 0;
        const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - headerHeight;

        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
      }
    });
  });


  /* ==========================================================================
     10. B2B Bulk Order Enquiry Modal & Submission Animation
     ========================================================================== */
  const bulkEnquiryModal = (() => {
    const modal = document.getElementById('bulk-enquiry-modal');
    const closeBtn = document.getElementById('modal-close-btn');
    const backdrop = document.getElementById('modal-backdrop');
    const doneBtn = document.getElementById('modal-done-btn');
    const formView = document.getElementById('modal-form-view');
    const successView = document.getElementById('modal-success-view');
    const form = document.getElementById('modal-bulk-form');
    const submitBtn = document.getElementById('modal-submit-btn');
    const productTag = document.getElementById('modal-product-tag');
    const productNameEl = document.getElementById('modal-product-name');

    if (!modal || !form) return;

    // Field references
    const fields = {
      fullName: {
        el: document.getElementById('modal-fullName'),
        error: document.getElementById('modal-error-fullName'),
        validate: (val) => val.trim().length >= 2
      },
      email: {
        el: document.getElementById('modal-email'),
        error: document.getElementById('modal-error-email'),
        validate: (val) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val.trim())
      },
      phone: {
        el: document.getElementById('modal-phone'),
        error: document.getElementById('modal-error-phone'),
        validate: (val) => val.trim().length >= 6
      },
      category: {
        el: document.getElementById('modal-category'),
        error: document.getElementById('modal-error-category'),
        validate: (val) => val && val.trim() !== ''
      },
      location: {
        el: document.getElementById('modal-location'),
        error: document.getElementById('modal-error-location'),
        validate: (val) => val.trim().length >= 2
      }
    };

    // Live validation
    Object.keys(fields).forEach((key) => {
      const field = fields[key];
      if (!field.el) return;

      const checkField = () => {
        const isValid = field.validate(field.el.value);
        if (isValid) {
          field.el.classList.remove('has-error');
          if (field.error) field.error.classList.remove('is-visible');
        }
      };

      field.el.addEventListener('input', checkField);
      field.el.addEventListener('change', checkField);
      field.el.addEventListener('blur', checkField);
    });

    function openModal(triggerElement) {
      // Check if opened from a product card
      const card = triggerElement ? triggerElement.closest('.product-card') : null;
      if (card) {
        const productTitle = card.querySelector('.product-title')?.textContent.trim();
        if (productTitle && productTag && productNameEl) {
          productNameEl.textContent = `Inquiring for: ${productTitle}`;
          productTag.style.display = 'inline-flex';
        }
        // Auto-select category if matching
        const isCopper = card.closest('#copper-products');
        const isBrass = card.closest('#brass-products');
        const categorySelect = document.getElementById('modal-category');
        if (categorySelect) {
          if (isCopper) categorySelect.value = 'Copper Products';
          else if (isBrass) categorySelect.value = 'Brass Products';
        }
      } else {
        if (productTag) productTag.style.display = 'none';
      }

      // Reset views
      formView.style.display = 'block';
      successView.setAttribute('hidden', '');

      // Open modal
      modal.classList.add('is-active');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';

      // Focus first input
      setTimeout(() => {
        const firstInput = document.getElementById('modal-fullName');
        if (firstInput) firstInput.focus();
      }, 150);
    }

    function closeModal() {
      modal.classList.remove('is-active');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      // Reset form errors
      Object.keys(fields).forEach((key) => {
        const field = fields[key];
        if (field.el) field.el.classList.remove('has-error');
        if (field.error) field.error.classList.remove('is-visible');
      });
    }

    // Attach open triggers to all "Enquire Bulk Quantity", "Enquire", and Modal trigger buttons
    const triggerButtons = document.querySelectorAll(
      '.quick-view-btn, .product-arrow-link, [data-open-modal="bulk-enquiry"]'
    );

    triggerButtons.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        openModal(btn);
      });
    });

    // Close triggers
    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    if (backdrop) backdrop.addEventListener('click', closeModal);
    if (doneBtn) doneBtn.addEventListener('click', closeModal);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.classList.contains('is-active')) {
        closeModal();
      }
    });

    // Form submission & animated transition
    form.addEventListener('submit', (e) => {
      e.preventDefault();

      let hasError = false;
      Object.keys(fields).forEach((key) => {
        const field = fields[key];
        if (!field.el) return;

        const isValid = field.validate(field.el.value);
        if (!isValid) {
          hasError = true;
          field.el.classList.add('has-error');
          if (field.error) field.error.classList.add('is-visible');
        } else {
          field.el.classList.remove('has-error');
          if (field.error) field.error.classList.remove('is-visible');
        }
      });

      if (hasError) {
        const firstErrorKey = Object.keys(fields).find((k) => fields[k].el.classList.contains('has-error'));
        if (firstErrorKey && fields[firstErrorKey].el) {
          fields[firstErrorKey].el.focus();
        }
        return;
      }

      // Start button loading animation
      if (submitBtn) {
        submitBtn.classList.add('is-loading');
        submitBtn.disabled = true;
      }

      const userName = fields.fullName.el.value.trim();
      const userEmail = fields.email.el.value.trim();
      const userCategory = fields.category.el.value;
      const userLocation = fields.location.el.value.trim();
      const refId = `#KT-${Math.floor(1000 + Math.random() * 9000)}`;

      // Simulate realistic processing delay and trigger luxurious animation
      setTimeout(() => {
        if (submitBtn) {
          submitBtn.classList.remove('is-loading');
          submitBtn.disabled = false;
        }

        // Fill dynamic success details
        const nameDisplay = document.getElementById('success-user-name');
        const emailDisplay = document.getElementById('success-user-email');
        const catDisplay = document.getElementById('success-category-name');
        const destDisplay = document.getElementById('success-destination');
        const refDisplay = document.getElementById('success-ref-id');

        if (nameDisplay) nameDisplay.textContent = userName;
        if (emailDisplay) emailDisplay.textContent = userEmail;
        if (catDisplay) catDisplay.textContent = userCategory;
        if (destDisplay) destDisplay.textContent = userLocation;
        if (refDisplay) refDisplay.textContent = refId;

        // Animate view transition
        formView.style.display = 'none';
        successView.removeAttribute('hidden');

        // Re-trigger SVG stroke checkmark animation
        const circle = successView.querySelector('.checkmark-circle');
        const check = successView.querySelector('.checkmark-check');
        if (circle && check) {
          circle.style.animation = 'none';
          check.style.animation = 'none';
          void circle.offsetWidth; // force reflow
          circle.style.animation = '';
          check.style.animation = '';
        }

        form.reset();
      }, 750);
    });
  })();

});
